import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal } from "./anim";
import { TESTIMONIALS } from "./data";

export const Testimonials = () => (
  <section
    data-testid="testimonials-section"
    className="relative mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-36"
  >
    <Reveal>
      <p className="mb-4 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[hsl(var(--muted))]">
        <span className="h-px w-8 bg-[hsl(var(--primary))]" /> Loved worldwide
      </p>
      <h2 className="max-w-3xl font-head text-4xl font-semibold leading-[1.05] sm:text-5xl lg:text-6xl">
        The first choice for brands that mean business.
      </h2>
    </Reveal>

    <div className="mt-16 grid gap-5 md:grid-cols-2">
      {TESTIMONIALS.map((t, i) => (
        <Reveal key={t.name} delay={(i % 2) * 0.1}>
          <motion.div
            whileHover={{ y: -6 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            data-testid={`testimonial-${i}`}
            className="flex h-full flex-col rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--bg-soft))] p-8"
          >
            <Quote className="mb-5 text-[hsl(var(--primary))]" size={30} />
            <p className="flex-1 text-lg leading-relaxed text-[hsl(var(--fg))]">
              “{t.quote}”
            </p>
            <div className="mt-7 border-t border-[hsl(var(--border))] pt-5">
              <p className="font-head text-lg font-semibold">{t.name}</p>
              <p className="text-sm text-[hsl(var(--muted))]">{t.role}</p>
            </div>
          </motion.div>
        </Reveal>
      ))}
    </div>
  </section>
);
